import { observer } from 'mobx-react';
import { FC } from 'react';
import ImageBlock from '../../../../containers/ImageBlock/ImageBlock';
import configWebStore from '../../stores';
import { IConfigWebImages } from '../../types';
import './style.scss';

const WebConfigImagesTab: FC = observer((): JSX.Element => {
  const { bannerImage, appBannerIcon, webHeaderLogo, webFooterLogo, favicon } = configWebStore.images;

  const uploadImage = (field: keyof IConfigWebImages) => (file: string) => {
    configWebStore.changeImages({ [field]: file });
  };

  return (
    <div className="d-flex flex-column flex-1 full-width mt-4 pr-4 gap-60">
      <ImageBlock
        type="banner"
        title="banner"
        image={bannerImage}
        uploadImage={uploadImage('bannerImage')}
        maxSize={2097152} // 2mb
      />

      <div className="d-flex flex-row gap-45 image-list">
        <ImageBlock
          type="app_header_logo"
          title="logo_for_website_header"
          image={webHeaderLogo}
          uploadImage={uploadImage('webHeaderLogo')}
          small={true}
          maxSize={51200} // 50kb
          maxResolution="104x52 px"
        />
        <ImageBlock
          type="app_banner_logo"
          title="logo_for_website_footer"
          image={webFooterLogo}
          uploadImage={uploadImage('webFooterLogo')}
          small={true}
          maxSize={2097152} // 2mb
          maxResolution="300x100 px"
        />
        <ImageBlock
          type="logo"
          title="download_app_banner_icon"
          image={appBannerIcon}
          uploadImage={uploadImage('appBannerIcon')}
          small={true}
          maxSize={2097152} // 2mb
          maxResolution="300x100 px"
        />
        <ImageBlock
          type="favicon"
          title="favicon"
          image={favicon}
          uploadImage={uploadImage('favicon')}
          small={true}
          maxSize={131072} // 128kb
          maxResolution="32x32 px"
        />
      </div>
    </div>
  );
});

export default WebConfigImagesTab;
